import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../../atoms';
import { DropdownMenuItem } from '../DropdownMenuItem';

const MetricMentionsDropdownItem = forwardRef((props, ref) => (
  <DropdownMenuItem
    ref={ref}
    {...props}
    leftIcon={<Icon name='hashtag' color='var(--content-subtitle)' size={20} />}
  >
    {props.itemValue}
  </DropdownMenuItem>
));

// lexical-beautiful-mentions specific props
MetricMentionsDropdownItem.propTypes = {
  'aria-label': PropTypes.string.isRequired,
  'aria-selected': PropTypes.bool.isRequired,
  item: PropTypes.shape({
    trigger: PropTypes.string,
    value: PropTypes.string.isRequired,
    displayValue: PropTypes.string.isRequired,
    data: PropTypes.shape({
      definition: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  itemValue: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  tabIndex: PropTypes.number.isRequired
};

export { MetricMentionsDropdownItem };
